import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'

const HeaderSettingsAlignment = ({
  classes,
  themeSettings,
  onThemeSettingsChange,
  pageUrl,
}) => {
  // Handle position selection
  const handlePositionSelect = position => {
    onThemeSettingsChange(position)
  }

  // Position option styles
  const getPositionStyle = position => {
    return {
      border:
        themeSettings.selectedPosition === position
          ? '1px solid var(--mcg-blue, #015FFB)'
          : '1px solid var(--Gray-Lighter, #E5E7EB)',
    }
  }

  // Position options data
  const positionOptions = [
    { value: 'left', label: 'Left' },
    { value: 'center', label: 'Center' },
    { value: 'right', label: 'Right' },
  ]

  return (
    <div className={classes.imageContent}>
      <div className={classes.imageContainer}>
        <Typography className={classes.imageHeader}>
          Content alignment
        </Typography>
      </div>
      <div className={classes.imageContent}>
        <Typography className={classes.imageText}>
          Choose how the logo, title, and button are positioned over the header
          image.
        </Typography>
      </div>

      {/* Position options */}
      <div className={classes.positionContainer}>
        {positionOptions.map(option => (
          <div className={classes.positionDiv} key={option.value}>
            <div
              className={classes.positionContent}
              onClick={() => handlePositionSelect(option.value)}
              style={getPositionStyle(option.value)}
            >
              <img
                src={`/assets/editor-file/landing-page/${
                  pageUrl === 'collection' ? 'collection' : 'course'
                }/default/${option.value}.svg`}
                alt={`${option.label} alignment`}
              />
            </div>
            <div className={classes.positionTextDiv}>
              <Typography className={classes.positionText}>
                {option.label}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsAlignment)
